import MailingAddress from './MailingAddressContainer';

export default MailingAddress;
